// extracted by mini-css-extract-plugin
module.exports = {"visualModalBodyHead":"visual-modal-body-head_component_visualModalBodyHead__dLriW"};